export default "__VITE_ASSET__B71StPr4__"